import { readGlobal } from 'oasis-os-common';
import { getCookie } from 'oasis-os-utils';
import { getSilentInfo } from './getSilentInfo';

const URLLocale = new URL(window.location.href)?.searchParams.get('locale');
const payloadLocaleObj = getSilentInfo('locale', URLLocale);
const payloadLocale = payloadLocaleObj.locale;

const getDefaultLocale = () => {
  const queryParamLocale = new URL(window.location.href)?.searchParams.get('locale');

  const cookieLocale = getCookie('defaultLocale');

  /**
   * if browser language is es-419 map it to our es-LA
   */
  const userLanguage =
    readGlobal('$.global.value.functionalConfig.i18n.useBrowser') &&
    (navigator.language === 'es-419' ? 'es-LA' : navigator.language);

  const globalConfigLocale = readGlobal(`$.global.value.functionalConfig.i18n.defaultLocale`);

  const defaultLocale =
    payloadLocale ||
    queryParamLocale ||
    cookieLocale ||
    userLanguage ||
    globalConfigLocale ||
    'en_US';

  return defaultLocale;
};

export default getDefaultLocale;
